<template>
	<div class="post-smtp-notice-wrapper">
		<div :class="classes">
			<div>
				<p class="post-smtp-notice-content">
					<span
						class="post-smtp-notice-icon"
					>
						<svg style="margin-bottom: -5px;" v-if="'success' === type" width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M8 0.100098C3.58 0.100098 0 3.6801 0 8.1001C0 12.5201 3.58 16.1001 8 16.1001C12.42 16.1001 16 12.5201 16 8.1001C16 3.6801 12.42 0.100098 8 0.100098ZM7.385 12.7601H6.045L2.805 8.2201L4.145 6.9701L6.715 9.3701L11.855 3.4401L13.195 4.3801L7.385 12.7601Z" fill="#6EB68B"/>
						</svg>

						<svg style="margin-bottom: -2px;" v-if="'warning' === type" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M8 0C12.42 0 16 3.58 16 8C16 12.42 12.42 16 8 16C3.58 16 0 12.42 0 8C0 3.58 3.58 0 8 0ZM13 11L10 8L13 5L11 3L8 6L5 3L3 5L6 8L3 11L5 13L8 10L11 13L13 11Z" fill="#CF6969"/>
						</svg>

					</span>

					<strong>
						<slot name="title"></slot>
					</strong>
					<slot name="message"></slot>
				</p>
			</div>
			<div>
				<slot name="button"></slot>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'postSmtpNotice',

	props: {
		type: {
			type: String,
			required: true,
		},
	},

	data: ( vm ) => ( {
		plugin_dir_url: vm.$parent.plugin_dir_url,
		admin_url: vm.$parent.admin_url,
	} ),

	computed: {
		classes() {
			return {
				'post-smtp-notice': true,
				'post-smtp-notice-success': this.type === 'success',
				'post-smtp-notice-error': this.type === 'error',
				'post-smtp-notice-warning': this.type === 'warning',
			};
		},
	},
}
</script>

<style scoped>
.post-smtp-notice-wrapper * {
	padding: 0;
	margin: 0;
}

.post-smtp-notice {
	width: calc( 100% - 33px );
	height: 44px;
	padding: 5px 16px 5px 16px;
	display: inline-flex;
	justify-content: space-between;
	align-items: center;
}

.post-smtp-notice-success {
	border-radius: 4px;
	border: 1px solid #DDE6E0;
	background: #F4F9F6;
}

.post-smtp-notice-warning {
	border-radius: 4px;
	border: 1px solid #E6DDDD;
	background: #F9F4F4;
}


.post-smtp-notice-content {
	color: #263E30;
	font-family: Poppins;
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: 18px;
}

.post-smtp-notice-content strong {
	font-weight: 600;

	padding-right: 4px;
}

.post-smtp-notice-icon {
	margin-right: 8px;
}
</style>